module.exports = __webpack_public_path__ + "img/carousel-productos-1.decd374d.jpg";